import { Button, Typography } from '@finam/web-ui-kit';
import React from 'react';

export const FinalStep: React.FC = () => {
    return <div className='step-final'>
        <h2>Оформление успешно завершено.</h2>
        <p>Если у вас удаленный режим работы, ознакомьтесь с обязательными шагами и оформите заявку на получение удаленного рабочего места:</p>
        <p className='step-description'>1.  Введите логин и пароль, полученный ранее в смс-сообщении (например логин: Office// vivanov; пароль (временный) 178345).   
        </p>
        <p className='step-description'>2.	Нажмите на созданную заявку на подключение и ознакомьтесь с регламентом, нажав на кнопку «Согласовать».</p>
        <p className='step-description'>3.  В течение 10 минут в согласованную заявку будет добавлена инструкция по подключению к рабочему месту.</p>
        <p className='step-description'>4.  Если возникнут вопросы или проблемы, свяжитесь со специалистом технической поддержки, оставив обращение в поле «Комментарии» или по телефону <b>+7 (495) 1-346-346 (доб. 1111).</b></p>
        <div style={{ margin: '14px 0px', textAlign: 'center' }}>
            <Button onClick={() => window.open('https://sd.finam.ru/servicedesk/customer/user/approvals?approvalQueryType=myApproval')}>Получить доступ</Button>
        </div>
        <div className='appLinksWrapper'>
            <div>
                <div><b>Будь в курсе!</b></div>
                <div>Устанавливай мобильное приложение Корпоративного портала и подписывайся на наш Телеграм канал, чтобы всегда быть в курсе последних новостей и иметь сервисы компании всегда под рукой.</div>
            </div>
            <div className='appLinks'>
                <div className='appLink'>
                    <img src={process.env.PUBLIC_URL + 'qr/qr_apple.png'} />
                    <span>Мобильное приложение <b>iOS</b></span>
                </div>
                <div className='appLink'>
                    <img src={process.env.PUBLIC_URL + 'qr/qr_android.png'} />
                    <span>Мобильное приложение <b>Android</b></span>
                </div>
                <div className='appLink'>
                    <img src={process.env.PUBLIC_URL + 'qr/qr_bot.png'} />
                    <span>Telegram бот</span>
                </div>
            </div>
            <div className='appLinksMobile'>
                <div className='appLink'>
                    <a href="https://apps.apple.com/us/app/finamportal/id1661616457"><img className='logo' src={process.env.PUBLIC_URL + 'icons/apple.svg'} /></a>
                </div>
                <div className='appLink'>
                    <a href="https://play.google.com/store/apps/details?id=ru.finam.portal"><img className='logo' src={process.env.PUBLIC_URL + 'icons/android.svg'} /></a>
                </div>
                <div className='appLink'>
                    <a href="https://t.me/finam_tg_bot"><img className='logo' src={process.env.PUBLIC_URL + 'icons/telegram.svg'} /></a>
                </div>
            </div>
        </div>
    </div>
}



